export const enum AcceptSOInteractionResponse
{
    Success = 1,
    InteractionNotFound = 2,
    AlreadyAcceptedByAnotherAgent = 3,
    Error = 4
}